import React, { PureComponent, createRef } from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
} from '@material-ui/core'
import { EditableSelect } from '../../../components/common/EditableComponents'
import EditActionComponent from '../../../components/common/EditActionComponent'

// actions
import {
  getPosTerminal,
  getPaymentsProcessor,
  getPosTerminals,
  addPosTerminal,
  updatePosTerminal,
  deletePosTerminal,
  getBlazePayProcessors,
  checkOnline,
  getDejavooShopConfig,
  updateDejavooShopConfigReceiptOption,
} from '../../../actions/dejavoo'
import { getCurrentSession } from '../../../actions/auth'
import { openErrorMessage } from '../../../actions/message'

// utils
import { hasAccess, getSession } from '../../../utils/api'

// local components
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import PosTerminalListItemContainer from '../../../components/Dejavoo/PosTerminalListItemContainer'
import ModalDialog from '../../../components/common/ModalDialog'
import AddPosTerminalModal from '../../../components/Modal/AddPosTerminalModal'
import { Appcues } from '../../../utils/constants'

class PosTerminals extends PureComponent {
  state = {
    selectedToDeleteTerminal: {},
    posTerminals: [],
    processors: [],
    paymentsProcessor: null,
    dejavooShopConfig: null,
    printReceiptOption: 'No',
    editMode: false,
  }

  addPosTerminalModal = createRef()

  componentDidMount() {
    this.onGetPaymentsProcessor()
    this.onGetPosTerminals()
    this.onGetBlazePayProcessors()
    this.onGetDejavooShopConfig()
    const session = getSession()
    // const blazePayPermission = session.assignedShop.paymentOptions.find(paymentOption => paymentOption.paymentOption == 'BlazePay');
    // if(!blazePayPermission || (blazePayPermission && !blazePayPermission.enabled)){
    //     this.props.history.push(`/settings/shop`);
    // }
    // this.props.dispatch(getCurrentSession());
  }

  onGetPaymentsProcessor = () => {
    this.props.dispatch(getPaymentsProcessor()).then((response) => {
      this.setState({
        paymentsProcessor: response,
      })
    })
  }

  onGetPosTerminals = () => {
    this.props.dispatch(getPosTerminals()).then((response) => {
      this.setState({
        posTerminals: [],
      })
      this.setState({
        posTerminals: response,
      })
    })
  }

  onGetBlazePayProcessors = () => {
    this.props.dispatch(getBlazePayProcessors()).then((response) => {
      this.setState({
        processors: response,
      })
    })
  }

  onGetDejavooShopConfig = () => {
    this.props.dispatch(getDejavooShopConfig()).then((response) => {
      this.setState({
        dejavooShopConfig: response,
        printReceiptOption: (response && response.printReceipt) || 'No',
      })
    })
  }

  onPosTerminalUpdate = (data, afterOnSave) => {
    if (this.validatePosTerminal(data)) {
      this.props.dispatch(updatePosTerminal(data)).then((response) => {
        Appcues.track('POS Terminal Info saved')
        this.onGetPosTerminals()
        afterOnSave(response)
      })
    }
  }

  openAddPosTerminalModal = () => {
    Appcues.track('Adding POS Terminal')
    this.addPosTerminalModal.current.handleClickOpen()
  }

  openDeleteModal = (item) => (e) => {
    this.setState({
      selectedToDeleteTerminal: item,
    })
    this.deleteModal.handleClickOpen()
  }

  checkOnlineStatus = (item) => (e) => {
    this.props.dispatch(checkOnline(item.id, item.registerId)).then((response) => {
      this.onGetPosTerminals()
    })
  }

  onDelete = (item) => (e) => {
    this.deleteModal.handleClose()
    this.props.dispatch(deletePosTerminal(item.id)).then((response) => {
      Appcues.track('POS Terminal deleted')
      this.onGetPosTerminals()
    })
  }

  addPosTerminal = (data) => {
    this.props.dispatch(addPosTerminal(data)).then((posTerminal) => {
      Appcues.track('New POS Terminal saved')
      this.onGetPosTerminals()
      this.addPosTerminalModal.current.handleClose()
    })
  }

  onError = (message) => this.props.dispatch(openErrorMessage(message))

  validatePosTerminal = (posTerminal) => {
    if (!posTerminal.name) {
      this.onError('Please enter POS Terminal name')
      return false
    }
    if (!posTerminal.serialNumber) {
      this.onError('Please enter POS Terminal serial number')
      return false
    }
    if (!posTerminal.registerId) {
      this.onError('Please enter POS Terminal register ID')
      return false
    }
    if (!posTerminal.authKey) {
      this.onError('Please enter POS Terminal auth key')
      return false
    }
    return true
  }

  enableEdit = () => {
    this.setState({
      editMode: true,
    })
  }

  disableEdit = () => {
    this.setState({
      editMode: false,
    })
  }

  onCancel = () => {
    const { dejavooShopConfig } = this.state
    this.setState({
      printReceiptOption: (dejavooShopConfig && dejavooShopConfig.printReceipt) || 'No',
      editMode: false,
    })
  }

  onSave = () => {
    this.props
      .dispatch(updateDejavooShopConfigReceiptOption(this.state.printReceiptOption))
      .then((response) => {
        Appcues.track('Shop POS Configuration saved')
        this.onGetDejavooShopConfig()
      })
    this.disableEdit()
  }

  onChange = (key) => (e) => {
    const value = e.target.value
    this.setState({
      [key]: value,
    })
  }

  render() {
    const { posTerminalReducer = {}, companyReducer } = this.props
    // const { posTerminals = {} } = posTerminalReducer || {};
    const permitted = hasAccess()
    const {
      selectedToDeleteTerminal,
      posTerminals,
      paymentsProcessor,
      dejavooShopConfig,
      printReceiptOption,
      editMode,
    } = this.state
    const blazepayProcesssor = (paymentsProcessor && paymentsProcessor.paymentsProcessor) || ''

    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={4} sm={4} md={4} lg={4}>
            <p>
              <strong>
                Payments Processor: {(paymentsProcessor && paymentsProcessor.realName) || ''}
              </strong>
            </p>
          </Grid>
          <Grid className="labelField" item xs={2} sm={2} md={2} lg={2}>
            {blazepayProcesssor === 'Vector' && <p>Payment Terminal Receipt</p>}
          </Grid>
          <Grid className="editField" item xs={2} sm={2} md={2} lg={2}>
            {blazepayProcesssor === 'Vector' && (
              <EditableSelect
                value={printReceiptOption}
                onChange={this.onChange('printReceiptOption')}
                valueToRender={printReceiptOption}
                editMode={true}
                disabled={!editMode}
                material={false}
                style={{ marginTop: 6 }}
              >
                <MenuItem value="No">None</MenuItem>
                <MenuItem value="Merchant">Merchant</MenuItem>
                <MenuItem value="Customer">Customer</MenuItem>
                <MenuItem value="Both">Both</MenuItem>
              </EditableSelect>
            )}
          </Grid>
          <Grid className="addButton" item xs={2} sm={2} md={2} lg={2}>
            {blazepayProcesssor === 'Vector' && permitted ? (
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.enableEdit}
                editMode={editMode}
              />
            ) : null}
          </Grid>
          <Grid className="addButton" item xs={2} sm={2} md={2} lg={2}>
            {permitted ? (
              <Button
                variant="raised"
                className="primary-button pull-right margin-bottom-small"
                onClick={this.openAddPosTerminalModal}
              >
                Add POS Terminal
              </Button>
            ) : null}
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper>
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Serial Number</TableCell>
                      <TableCell>Register ID</TableCell>
                      <TableCell>Auth Key</TableCell>
                      <TableCell>Online</TableCell>
                      <TableCell>Enabled</TableCell>
                      <TableCell>Manual</TableCell>
                      <TableCell>Processors</TableCell>
                      {permitted ? <TableCell>Actions</TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {posTerminals &&
                      posTerminals.length > 0 &&
                      posTerminals.map((row, index) => {
                        return (
                          <PosTerminalListItemContainer
                            key={index}
                            posTerminal={row}
                            onDelete={this.openDeleteModal(row)}
                            checkOnlineStatus={this.checkOnlineStatus(row)}
                            onPosTerminalUpdate={this.onPosTerminalUpdate}
                            processors={this.state.processors}
                          />
                        )
                      })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
          <AddPosTerminalModal
            ref={this.addPosTerminalModal}
            addPosTerminal={this.addPosTerminal}
            onError={this.onError}
            processors={this.state.processors}
          />
          <ModalDialog
            ref={(c) => (this.deleteModal = c)}
            onConfirm={this.onDelete(selectedToDeleteTerminal)}
            confirmText="delete"
          >
            Are you sure you want to delete '{selectedToDeleteTerminal.name}'
          </ModalDialog>
        </Grid>
      </div>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
  posTerminalReducer: state.posTerminalReducer,
  companyReducer: state.companyReducer,
}))(ContainerWithTitle(PosTerminals, 'Shop POS Terminal'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Dejavoo/PosTerminals.js